<script setup lang="ts">
  import lottie from 'lottie-web';
  import animationJson from '~/assets/animations/ida-animation.json';

  const animationRef = ref<HTMLElement | null>(null);

  onMounted(() => {
    if (!animationRef.value) return;

    lottie.loadAnimation({
      container: animationRef.value,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: animationJson,
      rendererSettings: {
        preserveAspectRatio: 'none'
      }
    });
  });
</script>

<template>
  <div class="chat-screen chat-splash-screen">
    <div class="chat-screen__wrapper">
      <h2>
        {{ $t('chat.splash.title') }}
        <span class="text-magenta">{{ $t('chat.splash.title2') }}</span>
      </h2>
      <div class="chat-splash-screen__animation">
        <div ref="animationRef" />
      </div>
    </div>
  </div>
</template>
